export default __webpack_public_path__ + "static/media/bookworm-red.29a4b0ca.svg";